export const pageTemplateConstants = {
 GET_TEMPLATELIST_REQUEST:         'GET_TEMPLATELIST_REQUEST',
 GET_TEMPLATELIST_SUCCESS:         'GET_TEMPLATELIST_SUCCESS',
 GET_TEMPLATELIST_FAILURE:         'GET_TEMPLATELIST_FAILURE',
 GET_TEMPLATEDETAIL_REQUEST: 	   'GET_TEMPLATEDETAIL_REQUEST',
 GET_TEMPLATEDETAIL_SUCCESS: 	   'GET_TEMPLATEDETAIL_SUCCESS',
 GET_TEMPLATEDETAIL_FAILURE: 	   'GET_TEMPLATEDETAIL_FAILURE',
 UPDATE_TEMPLATE_REQUEST: 		   'UPDATE_TEMPLATE_REQUEST',
 UPDATE_TEMPLATE_SUCCESS: 		   'UPDATE_TEMPLATE_SUCCESS',
 UPDATE_TEMPLATE_FAILURE: 		   'UPDATE_TEMPLATE_FAILURE',
 POST_EXECUTE_REQUEST: 			   'POST_EXECUTE_REQUEST',
 POST_EXECUTE_SUCCESS: 			   'POST_EXECUTE_SUCCESS',
 POST_EXECUTE_FAILURE: 			   'POST_EXECUTE_FAILURE',
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/pageTemplateConstants.js